/* global axios */

// [xleaders] XO-27 — sale thả/gỡ reaction lên tin khách (Zalo cá nhân). `icon` là mã Zalo
// (`/-heart`…), chuỗi rỗng = gỡ. `conversationDisplayId`: `conversation.id` phía frontend LÀ display_id.
export default {
  update(accountId, conversationDisplayId, messageId, icon) {
    return axios.put(
      `/api/v1/accounts/${accountId}/xleaders/conversations/${conversationDisplayId}/messages/${messageId}/zalo_reaction`,
      { icon }
    );
  },
};
